






























import { Vue, Component, Prop } from 'vue-property-decorator';
import ActionButtons from './ActionButtons.vue';

@Component({
  components: {
    ActionButtons,
  },
})
export default class EditDatabaseModal extends Vue {
  private inputType: string = 'password';
  @Prop(String) private currentDb!: string;
  @Prop(Function) private cancelHandler!: any;
  @Prop(Function) private submitRemoteForm!: any;
  @Prop(Function) private submitLocalForm!: any;
  @Prop(Function) private fillEditForm!: any;
  @Prop(Array) private regionList!: string[];
  @Prop(Object) private submitForm!: any;
  private created() {
    this.fillEditForm(this.currentDb);
  }

  private showSecretKey() {
    if (this.inputType === 'password') {
      this.inputType = 'text';
    } else {
      this.inputType = 'password';
    }
  }
}
